import { Box, Typography } from "@mui/material";
import { CheckCircle, CheckCircleOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface Props {
  value?: string;
  sx?: object;
}

const PasswordHints: React.FC<Props> = ({ value = "", sx }) => {
  const { t } = useTranslation();
  const rules: { label: string; met: boolean }[] = [
    { label: t("password.requirements.minLength"), met: value.length >= 8 },
    { label: t("password.requirements.uppercase"), met: /[A-Z]/.test(value) },
    { label: t("password.requirements.lowercase"), met: /[a-z]/.test(value) },
    { label: t("password.requirements.digit"), met: /\d/.test(value) },
    {
      label: t("password.requirements.special"),
      met: /[^a-zA-Z\d]/.test(value),
    },
  ];
  return (
    <Box sx={{ mt: 0.5, ...sx }}>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        {t("password.requirements.title")}
      </Typography>
      <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 0, listStyle: "none" }}>
        {rules.map(({ label, met }) => (
          <Box
            key={label}
            component="li"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              color: met ? "success.main" : "text.secondary",
              transition: "color 120ms ease",
            }}
          >
            {met ? (
              <CheckCircle sx={{ fontSize: 14 }} />
            ) : (
              <CheckCircleOutline sx={{ fontSize: 14, opacity: 0.6 }} />
            )}
            <Typography variant="caption">{label}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PasswordHints;
